import ApiRequestManagerInstance from '../ApiRequestManager';
import Rail from '../../classes/rail';
import { IRailsRequest } from '../../types/interfaces/rail';
import { store } from '../../store/store';

function moreContentRequest() {
  const promise = new Promise<Rail[]>(async (resolve) => {
    try {
      const { user } = store.getState();
      const response: IRailsRequest = (await ApiRequestManagerInstance.get({
        endpoint: {
          url: 'apiUrl',
          version: 'v8',
          section: user.isAnonymous ? 'mediafree' : 'media',
          subsection: 'morefun',
          type: 'morefun',
        },
      })) as unknown as IRailsRequest;
      let rails: Rail[] = [];
      if (response?.data?.length) {
        rails = response.data?.map((item) => new Rail(item));
      }
      resolve(rails);
    } catch (e) {
      console.error(e);
      resolve([]);
    }
  });

  return promise;
}

export default moreContentRequest;
